var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.showChat)?_c('ChatPopup',{attrs:{"friendId":_vm.chatFriendId,"friendUsername":_vm.chatFriendName},on:{"close":function($event){_vm.showChat = false}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }